import React from 'react';
import FaIcon from './FaIcon';
import JsxHelper from '../Helpers/JsxHelper';

class OverWindow extends React.Component
{
  static defaultProps = {
    clickOnCancel: () =>
    {
      alert('Define prop: clickOnCancel');
    },
    title: 'Default Title',
    children: <div className='border bg-warning'>This is the content.</div>,
    closeOnClickOutside: true,
    iconName: 'fa-solid fa-window-maximize',
    verticalScroll: true,
    bothScroll: false,
    maxWidth: 0,
    minHeight: '400px',
    className: '',
    zIndex: 1000
  };

  constructor (props)
  {
    super(props);
    this.windowref = React.createRef();

    this.escFunction = this.escFunction.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount ()
  {
    document.addEventListener('keydown', this.escFunction, false);
    if (this.props.closeOnClickOutside)
    {
      document.addEventListener('mousedown', this.handleClickOutside, false);
    }
  }

  componentWillUnmount ()
  {
    document.removeEventListener('keydown', this.escFunction, false);
    if (this.props.closeOnClickOutside)
    {
      document.removeEventListener('mousedown', this.handleClickOutside, false);
    }
  }

  escFunction (event)
  {
    if (event.keyCode === 27)
    {
      this.props.clickOnCancel();
    }
  }

  handleClickOutside (event)
  {
    if (this.props.closeOnClickOutside)
    {
      const node = this.windowref.current;

      if (event.target.contains(node))
      {
        event.preventDefault();
        this.props.clickOnCancel();
      }
    }
  }

  render ()
  {
    const style =
      this.props.maxWidth === 0
        ? {}
        : {
          maxWidth: `${this.props.maxWidth}px`,
          left: `calc(50% - ${this.props.maxWidth / 2}px)`,
          zIndex: this.props.zIndex
        };

    if (this.props.minHeight !== 0)
    {
      style.minHeight = typeof this.props.minHeight === 'string' ? this.props.minHeight : `${this.props.minHeight}px`;
    }
    return (
      <div className='disable-outside-clicks'>
        <div className='overWindowContainer'>
          <div className='top-of-box ' style={style} ref={this.windowref}>
            <div className='vw-100'>
              <div className='container-fluid h-100 ' style={{ zIndex: 100 }}>
                <div className='row  border rounded darkhoneydew'>
                  <div className='col '>
                    <div className='d-flex  '>
                      <h6 className='pl-1 pt-1 '>
                        <FaIcon iconName={this.props.iconName} className='text-primary' />
                        {JsxHelper.NonBreakableSpace()}
                        {this.props.title}
                      </h6>

                      <div className='text-right' style={{ marginRight: -15, marginLeft: 'auto' }}>
                        <FaIcon
                          className='btn btn-danger btn-sm '
                          iconName='fa-solid fa-circle-xmark'
                          onClick={() =>
                          {
                            this.props.clickOnCancel();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`row   ${this.props.verticalScroll ? 'verticalScroll' : ''} ${this.props.className}`}
                  style={{ height: 'calc(100% - 90px)' }}
                >
                  <div className='m-2 align-items-stretch'>{this.props.children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OverWindow;
